module.exports = {
  'align': {
    ''        : require('..//public/icons/align-left.svg'),
    'center'  : require('..//public/icons/align-center.svg'),
    'right'   : require('..//public/icons/align-right.svg'),
    'justify' : require('..//public/icons/align-justify.svg')
  },
  'background': require('..//public/icons/background.svg'),
  'blockquote': require('..//public/icons/blockquote.svg'),
  'bold'      : require('..//public/icons/bold.svg'),
  'clean'     : require('..//public/icons/clean.svg'),
  'code'      : require('..//public/icons/code.svg'),
  'code-block': require('..//public/icons/code.svg'),
  'color'     : require('..//public/icons/color.svg'),
  'direction' : {
    ''        : require('..//public/icons/direction-ltr.svg'),
    'rtl'     : require('..//public/icons/direction-rtl.svg')
  },
  'float': {
    'center'  : require('..//public/icons/float-center.svg'),
    'full'    : require('..//public/icons/float-full.svg'),
    'left'    : require('..//public/icons/float-left.svg'),
    'right'   : require('..//public/icons/float-right.svg')
  },
  'formula'   : require('..//public/icons/formula.svg'),
  'header': {
    '1'       : require('..//public/icons/header.svg'),
    '2'       : require('..//public/icons/header-2.svg')
  },
  'italic'    : require('..//public/icons/italic.svg'),
  'image'     : require('..//public/icons/image.svg'),
  'indent': {
    '+1'      : require('..//public/icons/indent.svg'),
    '-1'      : require('..//public/icons/outdent.svg')
  },
  'link'      : require('..//public/icons/link.svg'),
  'list': {
    'ordered' : require('..//public/icons/list-ordered.svg'),
    'bullet'  : require('..//public/icons/list-bullet.svg'),
    'check'   : require('..//public/icons/list-check.svg')
  },
  'script': {
    'sub'     : require('..//public/icons/subscript.svg'),
    'super'   : require('..//public/icons/superscript.svg'),
  },
  'strike'    : require('..//public/icons/strike.svg'),
  'underline' : require('..//public/icons/underline.svg'),
  'video'     : require('..//public/icons/video.svg')
};



// WEBPACK FOOTER //
// ./ui/icons.js